module.exports = __webpack_public_path__ + "static/media/info06_Declinado.156b2f55.png";